import debug from 'debug';
import { BaseActions } from '@/models/Common/Actions/BaseActions';
import TransportationRequestBuilder from '@/models/Transportation/TransportationRequestBuilder';
import { execAction } from '@/models/Common/Actions/handler';
import { ITransportationSearchTrainsRequestParams } from '@/models/Transportation/interfaces/ITransportationSearchTrainsRequestParams';
import { ITransportationSearchTrainPayload } from '@/models/Transportation/interfaces/payloads/ITransportationSearchTrainPayload';
import { ResponseEither } from '@/models/Common/ResponseEither';
import { ITransportationSearchTrainFaresRequestParams } from '@/models/Transportation/interfaces/ITransportationSearchTrainFaresRequestParams';
import { ITransportationSearchTrainFaresPayload } from '@/models/Transportation/interfaces/payloads/ITransportationSearchTrainFaresPayload';
import { ITransportationSearchTrainSeatMapCarriagesRequestParams } from '@/models/Transportation/interfaces/ITransportationSearchTrainSeatMapCarriagesRequestParams';
import { ITransportationSearchTrainSeatMapCarriagesPayload } from '@/models/Transportation/interfaces/payloads/ITransportationSearchTrainSeatMapCarriagesPayload';
import { ITransportationSearchTrainPackageFaresRequestParams } from '@/models/Transportation/interfaces/ITransportationSearchTrainPackageFaresRequestParams';
import { ITransportationSearchTrainPackageFaresPayload } from '@/models/Transportation/interfaces/payloads/ITransportationSearchTrainPackageFaresPayload';
import { ITransportationSearchTrainSeatMapCarriageRequestParams } from '@/models/Transportation/interfaces/ITransportationSearchTrainSeatMapCarriageRequestParams';
import { ITransportationSearchTrainSeatMapCarriagePayload } from '@/models/Transportation/interfaces/payloads/ITransportationSearchTrainSeatMapCarriagePayload';
import { ITransportationSearchTrainScheduleRequestParams } from '@/models/Transportation/interfaces/ITransportationSearchTrainScheduleRequestParams';
import { ITrainSchedulePayload } from '@/models/Transportation/interfaces/payloads/ITransportationSearchTrainSchedulePayload';
import { ITransportationSearchStationsRequestParams } from '@/models/Transportation/interfaces/ITransportationSearchStationsRequestParams';
import { ITransportationSearchStationsPayload } from '@/models/Transportation/interfaces/payloads/ITransportationSearchStationsPayload';

const log = debug('sunny:TransportationActions');

export default class TransportationActions extends BaseActions<TransportationRequestBuilder> {
  /** 전체역 검색 */
  searchStations(
    params: ITransportationSearchStationsRequestParams,
  ): Promise<ResponseEither<ITransportationSearchStationsPayload>> {
    log('Getting data of search stations');
    return execAction('search stations', this.requestBuilder.createSearchStationsQuery(params));
  }

  /** 기차 검색 */
  searchTrains(
    params: ITransportationSearchTrainsRequestParams,
  ): Promise<ResponseEither<ITransportationSearchTrainPayload[]>> {
    log('Getting data of search trains');
    return execAction('start search', this.requestBuilder.createSearchTrainsQuery(params));
  }

  /** 기차 요금 검색 */
  searchTrainFares(
    params: ITransportationSearchTrainFaresRequestParams,
  ): Promise<ResponseEither<ITransportationSearchTrainFaresPayload[]>> {
    log('Getting data of search train fares');
    return execAction('start search train fares', this.requestBuilder.createSearchTrainFaresQuery(params));
  }

  /** 기차 패키지 요금 검색 */
  searchTrainPackageFares(
    params: ITransportationSearchTrainPackageFaresRequestParams,
  ): Promise<ResponseEither<ITransportationSearchTrainPackageFaresPayload[]>> {
    log('Getting data of search train package fares');
    return execAction('start search train fares', this.requestBuilder.createSearchTrainPackageFares(params));
  }

  /** 열차별 호차 리스트 조회 */
  searchTrainSeatMapCarriages(
    params: ITransportationSearchTrainSeatMapCarriagesRequestParams,
  ): Promise<ResponseEither<ITransportationSearchTrainSeatMapCarriagesPayload[]>> {
    log('Getting data of search train seat map carriages');
    return execAction('start search train fares', this.requestBuilder.createSearchTrainSeatMapCarriages(params));
  }

  /** 호차별 잔여 좌석 조회 */
  searchTrainSeatMapCarriage(
    params: ITransportationSearchTrainSeatMapCarriageRequestParams,
  ): Promise<ResponseEither<ITransportationSearchTrainSeatMapCarriagePayload[]>> {
    log('Getting data of search train seat map carriage');
    return execAction('start search train fares', this.requestBuilder.createSearchTrainSeatMapCarriage(params));
  }

  /** 운행 시간 조회 */
  searchTrainSchedule(
    params: ITransportationSearchTrainScheduleRequestParams,
  ): Promise<ResponseEither<ITrainSchedulePayload[]>> {
    log('Getting data of search train schedule');
    return execAction('start search train schedule', this.requestBuilder.createSearchTrainSchedule(params));
  }
}
